import styled from "styled-components";
import { device } from "../../../stylesheet/breakpoints";
import SVG from "react-inlinesvg";

export const DateContainer = styled.div`
  width: 100%;
  margin-bottom: 20px;

  @media ${device.desktop} {
    width: 54%;
    margin-right: 40px;
    margin-bottom: 0;
  }

  & .rdp {
    --rdp-cell-size: 37px;
    margin: 0;
    color: var(--text-color);

    @media ${device.desktop} {
      --rdp-cell-size: 35px;
    }

    & .rdp-caption {
      position: relative;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 3px;
      background-color: rgba(255, 255, 255, 0.07);
      border-radius: 3px;
      padding: 10px 20px;

      & .rdp-caption_label {
        border: none;
        padding: 0;
        font-weight: 700;
        font-size: 13px;
        line-height: 1.2;
      }

      & .rdp-nav_button {
        position: absolute;
        top: 10px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: none;
        text-align: center;
        background-color: transparent;

        & svg {
          width: 10px;
          height: 10px;
        }
      }

      & .rdp-nav_button_previous {
        left: 10px;
      }

      & .rdp-nav_button_next {
        right: 10px;
      }
    }

    & .rdp-table {
      margin: 0 12px;
      font-weight: 400;
      font-size: 13px;
      line-height: 1.6;
    }

    & .rdp-day_selected {
      color: var(--text-color);
      background-color: var(--bg-button);
    }

    & .rdp-button:hover:not([disabled]):not(.rdp-day_selected) {
      background-color: rgba(255, 255, 255, 0.07);
    }
  }
`;

export const DateTitle = styled.h2`
  margin-bottom: 5px;
  text-align: start;
  font-weight: 400;
  font-size: 11px;
  line-height: 1.45;
  color: var(--text-color);

  @media ${device.desktop} {
    font-size: 13px;
    line-height: 1.6;
  }
`;

export const TimeTitle = styled(DateTitle)`
  position: absolute;
  left: 0;
  top: -21px;
`;

export const TimeContainer = styled.div`
  position: relative;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;

  @media ${device.desktop} {
    width: 46%;
    display: block;
  }
`;

export const InputLabel = styled.label`
  position: relative;
  display: block;
  height: 40px;
  margin-top: 21px;
  border: 1px solid transparent;
  background-color: rgba(255, 255, 255, 0.07);
  cursor: pointer;

  @media ${device.mobile} {
    &:not(:last-child) {
      margin-right: 20px;
    }
  }

  @media ${device.desktop} {
    width: 100%;
    display: block;
    margin-bottom: 40px;
  }
`;

export const InputTime = styled.input`
  width: 130px;
  height: 40px;
  border: 1px solid transparent;
  background-color: transparent;
  text-align: center;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.2;
  color: var(--text-color);
  cursor: pointer;

  &::-webkit-datetime-edit-text {
    padding: 0 10px;
  }

  &::-webkit-calendar-picker-indicator {
    opacity: 0;
  }

  &:hover,
  &:focus,
  &:focus-visible,
  &:active {
    border: 1px solid rgba(255, 255, 255, 0);
  }
`;

export const Icon = styled(SVG)`
  position: absolute;
  top: 13px;
  right: 12px;
  fill: currentColor;
  color: var(--text-color);
  pointer-events: none;

  @media ${device.desktop} {
    left: 65%;
  }
`;
